<template>
  <div class="loading-progress" v-if="showLoading">
    <div style="width: 100%;height:100%;position:fixed;">
      <div class="spinner" :style="'top:' + getMiddle + 'px'">
        <div class="loading"></div>
        <!--<img src="@/assets/images/loading.png"/>-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoadingProgress',
  props: {
    showLoading: {
      type: Boolean
    }
  },
  computed: {
    getMiddle () {
      return document.body.clientHeight / 2 - 40
    }
  }
}
</script>

<style scoped>
  @-webkit-keyframes loading{
    from {transform: rotate(0deg)}
    to {transform: rotate(359deg)}
  }

  @-moz-keyframes loading{
    from {transform: rotate(0deg)}
    to {transform: rotate(359deg)}
  }

  @keyframes loading{
    from {transform: rotate(0deg)}
    to {transform: rotate(359deg)}
  }
  .loading-progress {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9900;
  }
  .spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 40px;
    height: 40px;
  }
  .loading{
    width: 40px;
    height: 40px;
    background: url(../assets/images/loading-spinner.png) no-repeat center/100%;
    -webkit-animation: loading 1s infinite linear;
    -moz-animation: loading 1s infinite linear;
    animation: loading 1s infinite linear;
  }
</style>
